import { styled } from '@styledComponents';
import { animationTransition } from '@utils/animationTransition';
import { BaseImage } from '@components/CloudImage';
import { themeMediaQuery } from '@utils/styledTheme.util';

export const ECardWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

export const ECardImageWrapper = styled.div<{ aspectRatio: number }>`
  position: relative;
  width: ${({ aspectRatio }) => (isImageSquarish(aspectRatio) ? '80%' : aspectRatio > 1 ? '100%' : 'unset')};
  height: ${({ aspectRatio }) => (isImageSquarish(aspectRatio) ? '80%' : aspectRatio < 1 ? '100%' : 'unset')};
  cursor: pointer;
`;

const isImageSquarish = (aspectRatio: number) => {
  return aspectRatio >= 0.9 && aspectRatio <= 1.1;
};

const EcardProperties: string = `
  max-height: 100%;
  max-width: 100%;
  height: auto;
  transition: ${animationTransition('box-shadow')};
  display: block;
  ${themeMediaQuery('below_sm')} {
    width: auto;
  }
  `;

export const ECardImage = styled(BaseImage)<{ $isLoaded: boolean; $isHovered?: boolean; isDesign: boolean }>`
  ${EcardProperties};
  width: ${({ isDesign }) => (isDesign ? 350 : 231)}px !important;
  visibility: ${({ $isLoaded }) => ($isLoaded ? 'visible' : 'hidden')};
  box-shadow: ${({ $isHovered }) =>
    $isHovered
      ? '0px 30px 60px -12px rgba(68, 50, 93, 0.25), 0px 18px 36px -18px rgba(0, 0, 0, 0.3)'
      : '0px 4px 12px -2px rgba(68, 50, 93, 0.25), 0px 2px 7px -3px rgba(0, 0, 0, 0.3)'};
`;

export const EarlyLoadECardImage = styled.img<{ $isHovered?: boolean }>`
  ${EcardProperties};
  visibility: visible;
  box-shadow: ${({ $isHovered }) =>
    $isHovered
      ? '0px 30px 60px -12px rgba(68, 50, 93, 0.25), 0px 18px 36px -18px rgba(0, 0, 0, 0.3)'
      : '0px 4px 12px -2px rgba(68, 50, 93, 0.25), 0px 2px 7px -3px rgba(0, 0, 0, 0.3)'};
  width: 100%;
  height: 100%;
  ${themeMediaQuery('below_sm')} {
    width: 250px;
  }
  ${themeMediaQuery('sm')} {
    width: 265px;
  }
  ${themeMediaQuery('md')} {
    width: 390px;
  }
  ${themeMediaQuery('lg')} {
    width: 490px;
  }
  ${themeMediaQuery('xl')} {
    width: 650px;
  }
`;
